export const environment = {
  production: true,
  urlApiPrivate: '',
  urlApiPublic: '/home'
};
